import React from "react";
import { useParams, Link } from "react-router-dom";
import styled from "styled-components";
import people from "./pennpeople";
import { Helmet } from "react-helmet";

const Wrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80%;
  max-width: 650px;
  background: #1f1f1f;
  border: 1px solid #444;
  border-radius: 6px;
  padding: 20px;
  color: #f2f2f2;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  margin: 0 auto;
  margin-top: 20px;
`;

const BackLink = styled(Link)`
  align-self: flex-start;
  color: #cccccc;
  text-decoration: none;
  margin-bottom: 20px;
  text-decoration: underline;
  font-size: 16px;
  margin-bottom: 15px;
`;

const Name = styled.h1`
  margin: 0 0 10px;
  font-size: 1.6rem;
  font-weight: 700;
  text-align: center;
`;

const Title = styled.h3`
  margin: 0 0 8px;
  font-size: 1.1rem;
  font-weight: 500;
  color: #cccccc;
  text-align: center;
`;

const ShareBadge = styled.a`
  display: inline-block;
  padding: 6px 15px;
  border-radius: 1.2rem;
  font-size: 0.9rem;
  font-weight: bold;
  color: #1f1f1f;
  background-color: #ffffff;
  margin-top: 15px;
  text-decoration: none;
  &:hover {
    background-color: #aaa;
  }
`;

const AdminDetail: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const person = people.find((p) => p.slug === slug);
  const shareUrl = `https://trialhouse.com/penn/${slug}`;

  if (!person) {
    return (
      <Wrapper>
        <BackLink to="/penn">← Back to Penn employees</BackLink>
        <Card>
          <p>Administrator not found.</p>
        </Card>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Helmet>
        <title>
          {person.firstName} {person.lastName}
        </title>
        <meta
          name="description"
          content="Meet ${person.firstName} ${person.lastName}, ${person.title} at the University of Pennsylvania."
        />
      </Helmet>
      <BackLink to="/penn">← Back to Penn employees</BackLink>
      <Card>
        <Name>
          {person.firstName} {person.lastName}
        </Name>
        <Title>{person.title}</Title>

        {/* render any additional fields here */}

        <ShareBadge
          href={
            `https://twitter.com/intent/tweet` +
            `?url=${encodeURIComponent(shareUrl)}` +
            `&text=${encodeURIComponent(
              `Check this Ivy League employee: ${person.firstName} ${person.lastName}, ${person.title} at @Penn.`
            )}`
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          Share on X
        </ShareBadge>
      </Card>
    </Wrapper>
  );
};

export default AdminDetail;
